import { useQuery } from '@apollo/client/react'
import {
  OrgTicketScopeDocument,
  type OrgTicketScopeQuery,
} from '@/graphql/generated/graphql'

export type OrgTicketScopeBusiness =
  OrgTicketScopeQuery['orgTicketScope']['businesses'][number]

export interface OrgTicketScope {
  /** El usuario es propietario de la organización (ve toda su jerarquía). */
  isOrgOwner: boolean
  /** Tiene alcance (organización o negocios): puede crear tickets. */
  canCreate: boolean
  /** Negocios contra los que puede crear (selector del form). */
  businesses: OrgTicketScopeBusiness[]
}

/**
 * Alcance del usuario sobre los tickets del portal (goal
 * portal-tickets-alcance-por-membresia), resuelto SERVER-SIDE por
 * tickets-server (Zeus + Identity). Gatea la sección completa: `hasScope`
 * decide si se pinta la entrada del sidebar y las rutas /app/tickets*.
 * Un usuario sin organización ni negocios recibe alcance vacío (sin error);
 * si el backend no responde se trata como sin alcance (fail-closed en la UI
 * — el gate real vive en el server).
 */
export function useOrgTicketScope() {
  const { data, loading, error } = useQuery(OrgTicketScopeDocument, {
    fetchPolicy: 'cache-first',
  })
  const scope: OrgTicketScope = {
    isOrgOwner: data?.orgTicketScope.isOrgOwner ?? false,
    canCreate: data?.orgTicketScope.canCreate ?? false,
    businesses: data?.orgTicketScope.businesses ?? [],
  }
  return {
    scope,
    hasScope: scope.canCreate,
    loading,
    error,
  }
}
